import React from "react";
import { motion } from "framer-motion";

export const easeOutExpo = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 34 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: easeOutExpo },
  }),
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};

export function Reveal({ children, className = "", delay = 0, y = 34, as = "div", once = true }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: easeOutExpo }}
    >
      {children}
    </Comp>
  );
}

// Line-by-line masked reveal for headings
export function MaskLines({ lines, className = "", startDelay = 0.15, wordClassName = "" }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            style={{ display: "block" }}
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{ duration: 0.95, delay: startDelay + i * 0.12, ease: easeOutExpo }}
            className={wordClassName}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
